// @ngInject
function Rms2OrdersApiService($q, $window, $cookies, DS, DSHttpAdapter, ResourcesService) {

    var endpoint = 'purchaseorder';

    return {
        getCountries: ResourcesService.apiRms2Factory.get('country/countries'),
        deliverStoreOrder: deliverStoreOrder,
        deliverAutoOrder: deliverAutoOrder,
        getAll: getAll,
        deliverInternalOrder: deliverInternalOrder,
        deliverAutoInternalOrder: deliverAutoInternalOrder,
        deliverReturnOrder: deliverReturnOrder,
        updateCommentOnOrderRows: updateCommentOnOrderRows
    };

    function getAll(searchTerms) {
        var deferred = $q.defer();
        var params = {};

        if (searchTerms.page && searchTerms.page < 0) {
            searchTerms.page = 1;
        }

        if (searchTerms.limit && searchTerms.limit > 0) {
            params.limit = searchTerms.limit;
        }

        if (!_.isEmpty(searchTerms.searchTerm)) {
            params.searchTerm = searchTerms.searchTerm;
        }

        params.page = searchTerms.page;
        params.orderTypes = searchTerms.orderTypes;
        params.onlyUndelivered = searchTerms.showUndeliveredOnly;
        params.onlyUnprinted = searchTerms.showUnprintedOnly;
        params.onlyUnapproved = searchTerms.showUnapprovedOnly;
        params.onlyOrderNumber = searchTerms.onlyOrderNumber;
        params.monthBack = searchTerms.monthBack;

        DSHttpAdapter.GET(DS.defaults.rms2Path + 'purchaseorder/search', { params: params }).then(function getAllOrders(response) {
            deferred.resolve(response.data.data);
        }, function getAllOrdersError(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deliverStoreOrder(request) {
        var transactionId = crypto.randomUUID();
        var deliveryRequest = {
            orderId: request.orderId,
            deliveringUserId: request.deliveringUserId,
            lineItems: []
        }
        _.forEach(request.lineItems, function(lineItem) {
            deliveryRequest.lineItems.push({
                id: transactionId,
                quantity: lineItem.quantity,
                lineNumber: lineItem.lineNumber,
                date: lineItem.date,
                closeDelivery: !lineItem.restDelivery
            });
        });

        var jsonData = JSON.stringify(deliveryRequest);

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.rms2Path + endpoint + '/deliverPurchaseOrder', jsonData).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deliverAutoOrder(request) {
        var transactionId = crypto.randomUUID();
        var deliveryRequest = {
            orderId: request.orderId,
            deliveringUserId: request.deliveringUserId,
            lineItems: []
        }
        _.forEach(request.lineItems, function(lineItem) {
            deliveryRequest.lineItems.push({
                id: transactionId,
                quantity: lineItem.quantity,
                lineNumber: lineItem.lineNumber,
                date: lineItem.date,
                closeDelivery: !lineItem.restDelivery
            });
        });

        var jsonData = JSON.stringify(deliveryRequest);

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.rms2Path + endpoint + '/deliverAutoOrder', jsonData).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deliverInternalOrder(request) {
        var transactionId = crypto.randomUUID();
        var deliveryRequest = {
            orderId: request.orderId,
            deliveringUserId: request.deliveringUserId,
            lineItems: []
        }
        _.forEach(request.lineItems, function(lineItem) {
            deliveryRequest.lineItems.push({
                id: transactionId,
                quantity: lineItem.quantity,
                lineNumber: lineItem.lineNumber,
                date: lineItem.date,
                closeDelivery: !lineItem.restDelivery
            });
        });

        var jsonData = JSON.stringify(deliveryRequest);

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.rms2Path + endpoint + '/deliverInternalOrder', jsonData).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deliverAutoInternalOrder(request) {
        var transactionId = crypto.randomUUID();
        var deliveryRequest = {
            orderId: request.orderId,
            deliveringUserId: request.deliveringUserId,
            lineItems: []
        }
        _.forEach(request.lineItems, function(lineItem) {
            deliveryRequest.lineItems.push({
                id: transactionId,
                quantity: lineItem.quantity,
                lineNumber: lineItem.lineNumber,
                date: lineItem.date,
                closeDelivery: !lineItem.restDelivery
            });
        });

        var jsonData = JSON.stringify(deliveryRequest);

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.rms2Path + endpoint + '/deliverAutoInternalOrder', jsonData).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deliverReturnOrder(request) {
        var transactionId = crypto.randomUUID();
        var deliveryRequest = {
            orderId: request.orderId,
            deliveringUserId: request.deliveringUserId,
            lineItems: []
        }
        _.forEach(request.lineItems, function(lineItem) {
            deliveryRequest.lineItems.push({
                id: transactionId,
                quantity: lineItem.quantity,
                lineNumber: lineItem.lineNumber,
                date: lineItem.date,
                closeDelivery: !lineItem.restDelivery
            });
        });

        var jsonData = JSON.stringify(deliveryRequest);

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.rms2Path + endpoint + '/deliverReturnOrder', jsonData).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updateCommentOnOrderRows(orderRows){
        var deferred = $q.defer();

        var request = {
            comment: orderRows[0].comment,
            orderRowIds: []
        };

        _.forEach(orderRows, function(row){
            request.orderRowIds.push(row.id);
        });

        DSHttpAdapter.PUT(DS.defaults.rms2Path + endpoint + '/updateOrderRowComment', request).then(function(response){
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });
        
        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('orders.api2', [])
    .factory('Rms2OrdersApiService', Rms2OrdersApiService);
